import { VFilterBar, type VFilterBarOption } from '@vrzl/ui';

import type { ValidationCounts, ValidationFilter } from '../utils/validationView';

const OPTIONS: ReadonlyArray<VFilterBarOption<ValidationFilter>> = [
  { value: 'all', label: 'Alles' },
  { value: 'present', label: 'Aanwezig' },
  { value: 'missing', label: 'Niet aanwezig' },
];

type ValidationFilterBarProps = {
  value: ValidationFilter;
  /** Over alle actieve criteria, los van de zoekterm. */
  counts: ValidationCounts;
  onChange: (value: ValidationFilter) => void;
};

export function ValidationFilterBar({ value, counts, onChange }: ValidationFilterBarProps) {
  return (
    <VFilterBar
      options={OPTIONS}
      value={value}
      counts={{ all: counts.all, present: counts.present, missing: counts.missing }}
      onChange={onChange}
      ariaLabel="Filter criteria op aanwezigheid"
    />
  );
}
